import { proxy } from 'valtio';
export const a2330_store = proxy({
    stockSelectionType: 'long',
    stockSelectionCondition: [],
    stockSelectedFirebase: false,
    stockSymbol: ['2330'],
    filterStockFutures: false,
    searchedSymbol: [],
});
